export const environment = {
    production: false,
    debug     : true,
    showRibbon: false,
    api       : {
        graphql: 'https://itp-digitai-aurora-back-qa.azurewebsites.net/graphql',
        rest   : 'https://itp-digitai-aurora-back-qa.azurewebsites.net/',
    },
    lang: {
        base    : 'en',
        fallback: 'en',
        langs   : ['es','en'],
    },
    oAuth: {
        applicationCode  : 'digitai',
        applicationSecret: 'CrSoO&amp;eO7h8gkUED@Xxdgh7AFiBCnthEld2z6S$RC~rt1bgg',
    },
    appearance: {
        theme : 'theme-default',
        layout: 'classy',
    }
};
